import {
    Component, EventEmitter,
    Input,
    OnInit,
    Output
} from '@angular/core';

@Component({
    selector: 'app-user-icon-list',
    templateUrl: './user-icon-list.component.html',
    styleUrls: ['./user-icon-list.component.css']
})

export class UserIconListComponent implements OnInit {
    @Input() usersList: any;
    @Input() imageList: any [];
    @Input() isGridCell: any;
    constructor() { }

    ngOnInit() {
    }

    ngOnChanges(){
    }
}
